module.exports = __webpack_public_path__ + "img/logo_color.c58fb992.png";